import React__default__default from 'react';
import ReactUtils from '../react-utils/react-utils.js';
import Label from '../../components/_atoms/label/label.js';

/**
 * Concatenates original component extraClasses prop (when available) with new classes to inject.
 * Use case: when cloning children to preserve user given extraClasses.
 * @param {ReactElement} component
 * @param {string} injectedExtraClasses
 * @returns 'original-component-extraClasses' + 'injected-extra-classes'
 */
function handleExtraClasses(component, injectedExtraClasses) {
  var compExtraClasses = component.props.extraClasses ? "".concat(component.props.extraClasses, " ") : '';
  return "".concat(compExtraClasses).concat(injectedExtraClasses);
}
/**
 *Concatenates original component aria-describedby prop (when available) with new
 * ids to inject.
 * Use case: on input fields with info error and other custom description fields.
 * @param {string} addedDescription
 * @param {string} ariaDescribedByProp
 * @returns
 */
function handleAriaDescribedBy(addedDescription, ariaDescribedByProp) {
  var describedByIds = addedDescription ? [addedDescription.trim()] : [];
  if (ariaDescribedByProp) describedByIds.push(ariaDescribedByProp.trim());
  return describedByIds.length ? describedByIds.join(' ').trim() : undefined;
}
/**
 * Creates a Label component for an input with a given node as text and respective for={id} and
 * component extraClasses.
 *
 * Or clones a given Label component adding the input specific props.
 *
 * Used by input components to handle their given label props.
 *
 * @param {LabelComp | ReactNode} label Label component or a ReactNode
 * @param {string} id The input id used on the label `for` attribute
 * @param {HoneyBemInstance} bem The parent bem instance
 * @param {string=} requiredText Deprecated: "required" text for generated Label
 * @returns A Label component for the input.
 */
function handleLabel(label, id, bem, requiredText) {
  if (ReactUtils.isOfType(label, 'Label')) {
    var labelComponent = label;
    return /*#__PURE__*/React__default__default.cloneElement(labelComponent, {
      extraClasses: handleExtraClasses(labelComponent, bem.e('label')),
      labelFor: id
    });
  }
  return /*#__PURE__*/React__default__default.createElement(Label, {
    text: label,
    labelFor: id,
    requiredText: requiredText,
    extraClasses: bem.e('label')
  });
}
var PropsUtils = {
  handleExtraClasses: handleExtraClasses,
  handleAriaDescribedBy: handleAriaDescribedBy,
  handleLabel: handleLabel
};

export { PropsUtils as default };
